import React, { useEffect, useState } from 'react';
import { useOrderLocation } from "@/hooks/api/order";

const { headoffice, app } = Mobi2Go;

const { language, platform } = app;

const WEB = 'web';

const platform_whitelist = [
    'web',
    'mobile',
    'ios',
    'android'
]

const Banner = () => {
    const [banners, setBanners] = useState(headoffice.banners);
    const location = useOrderLocation();

    useEffect(() => {
        if (location) {
            const locationBanners =
                headoffice.banners.filter(banner => banner.locations && banner.locations.includes(location.id));

            setBanners(locationBanners.length
                ? locationBanners
                : headoffice.banners
            )
        }
    }, [location])

    const getImage = banner => (
        <img
            className="m2g-hero-image"
            alt={banner.name}
            src={platform === WEB ? banner.desktop_image : banner.mobile_image}
        />
    )

    const shouldRender = banner =>
        platform_whitelist.includes(platform) && (
            (platform === WEB && banner.desktop_image) ||
            (platform !== WEB && banner.mobile_image)
        ) && (!banner.languages || banner.languages.includes(language))
        && (!banner.locations || (location && banner.locations.includes(location.id)))

    const getHTML = banner => (
        <div
            key={banner.id}
            className={`m2g-hero ${platform === WEB ? 'm2g-hero-desktop' : 'm2g-hero-mobile'}`}
        >
            {banner.actions && banner.actions[0]
                ?
                <a className="m2g-hero-link" href={'#' + banner.actions[0].type} title={banner.actions[0].target}>
                    { getImage(banner) }
                </a>
                : getImage(banner)
            }
        </div>
    )

    if (!banners || !banners.length) return null;

     return (
         <div style={{display: 'block'}}>
             {banners.map(banner => shouldRender(banner) ? getHTML(banner) : '')}
         </div>
     )
}

export default Banner;
